import { awaitJSON, MiscLambdaFetch } from '@src/utils/fetch-utils';

export interface AmcInstanceMappingParams {
  company: string;
  amcInstanceId: string;
}

export const createAmcInstanceIdMapping = async (
  clientInfoParams: AmcInstanceMappingParams
): Promise<{ statusCode: number; body: string }> => {
  const res = await MiscLambdaFetch('/createAmcInstanceIdMapping', {
    method: 'POST',
    body: JSON.stringify(clientInfoParams)
  });
  return awaitJSON(res);
};

export const getAmcInstanceIdMapping = async (
  company: string
): Promise<AmcInstanceMappingParams[]> => {
  const res = await MiscLambdaFetch('/getAmcInstanceIdMapping', {
    method: 'GET',
    params: { company }
  });
  return awaitJSON(res);
};
